import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";
import { AssistantValue } from "../../../services/api/instances/assistantsApi/types";

export const selectAssistantsState = (state: RootState) =>
  state.assistantsState;

export const selectAssistantValue = createSelector(
  selectAssistantsState,
  (state) => {
    return state.assistantValue;
  },
);

export const selectAssistantMeta = createSelector(
  selectAssistantsState,
  (state) => {
    return state.assistantValue?.meta;
  },
);

export const selectMessages = createSelector(selectAssistantsState, (state) => {
  return state.messages;
});

export const selectAssistantFunctions = createSelector(
  selectAssistantsState,
  (state) => {
    return state.assistantFunctions;
  },
);

export const selectMessageLoadingInfo = createSelector(
  selectAssistantsState,
  (state) => {
    return state.messageLoadingInfo;
  },
);

export const selectSkills = createSelector(selectAssistantsState, (state) => {
  return state.skills;
});

export const selectChatHistory = createSelector(
  selectAssistantsState,
  (state) => {
    return state.chatHistory;
  },
);

export const selectOpenAiAssistantIds = createSelector(
  selectAssistantsState,
  (state) => {
    return state.openAiAssistantsIds;
  },
);

export const selectIsServiceLoading = createSelector(
  selectAssistantsState,
  (state) => {
    return state.isServiceLoading;
  },
);

export const selectIsFunctionsLoading = createSelector(
  selectAssistantsState,
  (state) => {
    return state.isFunctionsLoading;
  },
);

export const selectIsFileLoading = createSelector(
  selectAssistantsState,
  (state) => {
    return state.isFileLoading;
  },
);

export const selectChatLogs = createSelector(selectAssistantsState, (state) => {
  return state.chatLogs;
});

export const selectSwitchedDialogs = createSelector(
  selectAssistantsState,
  (state) => {
    return state.assistantValue?.assistant_object?.metadata?.dialogs === "true";
  },
);

export const selectAssistantField = <
  K extends keyof AssistantValue["assistant_object"],
>(
  field: K,
) =>
  createSelector(
    (state: RootState) =>
      state.assistantsState.assistantValue?.assistant_object,
    (assistantObject) => assistantObject?.[field],
  );
